import { Log, UpdatedRecordsType } from '@/types/logs'
import {
    checkIsRecordUnfinished,
    checkIsfRecordFlagged,
    checkIsOfficialReportMissing,
    checkIsMechanicalInfoMissing,
} from './checkRecords'

export const getUnfinishedType = (log: Log): UpdatedRecordsType | undefined => {
    let unfinishedType

    if (checkIsRecordUnfinished(log)) {
        unfinishedType = UpdatedRecordsType.Unfinished
    }

    if (checkIsfRecordFlagged(log)) {
        unfinishedType = UpdatedRecordsType.Flagged
    }

    if (checkIsOfficialReportMissing(log)) {
        unfinishedType = UpdatedRecordsType.MissingOfficialReport
    }

    if (checkIsMechanicalInfoMissing(log)) {
        unfinishedType = UpdatedRecordsType.MissingInfo
    }

    return unfinishedType
}

export const markUpdatedRecords = (logs: Log[]): Log[] =>
    logs.map((log) => {
        return { ...log, unfinishedType: getUnfinishedType(log) }
    })
